import React, { useState, useEffect } from "react";

const Timeline = ({ value, time,timevalue,selectRange }) => {
  const [timeSlots, setTimeSlots] = useState([]);
  useEffect(() => {
    const slots = [];
     
    const numberToWords = {
      1: "one", 2: "two", 3: "three", 4: "four", 5: "five",
      6: "six", 7: "seven", 8: "eight", 9: "nine", 10: "ten",
      11: "eleven",12:"twelve"
    };
    
    

    const selectedDate = new Date(value);
    const today = new Date();

    const isToday = selectedDate.toDateString() === today.toDateString();

    const start = new Date(selectedDate);

    if (isToday) {
      const now = new Date();
      start.setHours(
        now.getMinutes() < 30 ? now.getHours() + 1 : now.getHours() + 1
      );
      start.setMinutes(0, 0, 0);
    } else {
      start.setHours(10, 0, 0, 0); // Start from 9:00 AM
    }

    const end = new Date(selectedDate);
    end.setHours(18, 0, 0, 0); // Last available slot is 5:00 PM

    while (start < end) {
      const startStr = start.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      const endSlot = new Date(start.getTime() + 60 * 60000); // 1 hour
      const endStr = endSlot.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      const [hourStr, period,date] = startStr.split(/[: ]/); // ["5", "00", "PM"]
      const hour = parseInt(hourStr);
      const periodStr = date.toLowerCase(); // "am" or "pm"
    
      const word = numberToWords[hour];
      const slotKey = word + periodStr.toUpperCase();
      console.log(startStr, "getting time");
      slots.push({ start: startStr, key:slotKey  });

      start.setMinutes(start.getMinutes() + 60);
    }

    setTimeSlots(slots);
  }, [value]);


  const handleChange = (slot) => {
    console.log(slot.start, "checking time");
    time(slot.start); // You could also store full `slot` object
    // Assuming `time` is a function (e.g. `setTime`)
  };

  return (
    <div
      style={{
        padding: "1rem",
        textAlign: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        overflowX: "hidden",
        overflowY: timeSlots.length > 3 ? "auto" : "hidden",
        height: "100%",
        // width: "50%",
      }}
    >
      {console.log(timeSlots,selectRange, " timeSlots.length")}
      {/* <p
        style={{
          margin: "10px",
          padding: "0px 24px",
        }}
      >
        {new Date(value).toDateString()}
      </p> */}
      <div
        style={{
          height: "100%",
          width: "100%",
          // overflow: "hidden scroll",
          paddingRight: "10px", // extra spacing to avoid scrollbar overlap
        }}
      >
        {timeSlots.length > 0 ? (
          timeSlots.map((slot, index) => {
            const isSelected = timevalue === slot.start;
            const isDisabled = selectRange.includes(slot.key);
            console.log(timevalue,"timevalue")
            return (
            <div
              key={index}
              style={{
                padding: "12px 24px",
                border: "1px solid #488257",
                color: isSelected
                ? "white"
                : isDisabled
                ? "#aaa"
                : "#488257",
              backgroundColor: isSelected
                ? "#488257"
                : isDisabled
                ? "#f0f0f0"
                : "white",
                cursor: selectRange.includes(slot.key) ? "not-allowed" : "pointer",
                opacity: selectRange.includes(slot.key) ? 0.6 : 1,
                borderRadius: "12px",
                fontWeight: "bold",
                fontSize: "16px",
                textAlign: "center",
                width: "100%",
                margin: "10px",
                boxShadow: "0 0 4px rgba(33, 150, 243, 0.2)",
                cursor: "pointer",
                transition: " all 0.3s ease",
                
              }}
              onClick={() =>selectRange.includes(slot.key)?undefined: handleChange(slot)}
            >
              {slot.start}
            </div>
          )})
        ) : (
          <div
            // key={index}
            style={{
              padding: "12px 24px",
              // border: "1px solid #488257",
              color: "red",
              borderRadius: "12px",
              fontWeight: "bold",
              fontSize: "16px",
              textAlign: "center",
              width: "100%",
              margin: "10px",
              // boxShadow: "0 0 4px rgba(33, 150, 243, 0.2)",
              cursor: "pointer",
              transition: " all 0.3s ease",
            }}
          >
            No time slot Available
          </div>
        )}
      </div>
    </div>
  );
};

export default Timeline;
